import { sendRequestToServer } from "@src/utility_functions/database_operations/sendRequestToServer";

export const createRowWithIntervals = async (newRowObject) => {
  const serverPayload = {
    payload: {
      timeline: {
        label: newRowObject.label,
        description: newRowObject.description,
        primaryColor: newRowObject.primaryColor,
        secondaryColor: newRowObject.secondaryColor,
        publishStatus: newRowObject.publishStatus,
      },
      intervals: newRowObject.intervals,
      metadata: {
        source: newRowObject.source,
        chartType: newRowObject.chartType,
        chartID: newRowObject.chartID,
      },
    },
  };
  const returnObject = await sendRequestToServer(
    serverPayload,
    "/server/database_operations/rows/createRowWithIntervals",
  );
  return returnObject;
};
